import axios from 'axios'
import { config, url } from '../../index'
import router from '../../../router'

const state = () => ({
  groups: [],
  createModal: {
    active: false,
    name: '',
    color: '#173F7D',
    members: []
  },
  listIsLoading: true,
  listSearchValue: '',
  listSort: {
    value: { id: 1, name: 'Не выбрано', value: 'id' },
    options: [
      { id: 1, name: 'Не выбрано', value: 'id' },
      { id: 2, name: 'По алфавиту', value: 'name' },
      { id: 3, name: 'По дате создания', value: 'created_at' }
    ]
  },
  pagination: {
    pageList: {
      active: false,
      pages: []
    },
    currentTake: 10,
    currentPage: 1,
    lastPage: 0
  },
  group: {},
  updateModal: {
    active: false,
    name: '',
    color: '',
    members: []
  },
  detailIsLoading: true
})

const getters = {
  // список групп
  userGroups: state => state.groups,
  userGroupsCreateModal: state => state.createModal,
  userGroupsSearchValue: state => state.listSearchValue,
  userGroupsSort: state => state.listSort,
  userGroupsIsLoading: state => state.listIsLoading,
  userGroupsPagination: state => state.pagination,
  // деталка группы
  userGroupDetail: state => state.group,
  userGroupDetailUpdateModal: state => state.updateModal,
  userGroupDetailIsLoading: state => state.detailIsLoading
}

const mutations = {
  // список групп
  GET_USER_GROUPS: (state, groups) => {
    state.groups = groups

    state.listIsLoading = false
  },
  SHOW_USER_GROUPS_CREATE_MODAL: (state) => {
    state.createModal.active = true
  },
  SET_USER_GROUPS_CREATE_MODAL_NAME: (state, name) => {
    state.createModal.name = name
  },
  SET_USER_GROUPS_CREATE_MODAL_COLOR: (state, color) => {
    state.createModal.color = color
  },
  ADD_USER_GROUPS_CREATE_MODAL_MEMBER: (state, user) => {
    state.createModal.members.push(user)
  },
  REMOVE_USER_GROUPS_CREATE_MODAL_MEMBER: (state, user) => {
    state.createModal.members = state.createModal.members.filter(member => {
      return member.id !== user.id
    })
  },
  CLOSE_USER_GROUPS_CREATE_MODAL: (state) => {
    state.createModal.active = false
  },
  CLEAR_CLOSE_USER_GROUPS_CREATE_MODAL: (state) => {
    state.createModal.active = false
    state.createModal.name = ''
    state.createModal.color = '#173F7D'
    state.createModal.members = []
  },
  SET_USER_GROUPS_SEARCH_VALUE: (state, value) => {
    state.listSearchValue = value
  },
  SET_USER_GROUPS_SORT: (state, sort) => {
    state.listSort.value = sort
  },
  SET_USER_GROUPS_IS_LOADING: (state) => {
    state.listIsLoading = true
  },

  // деталка группы
  GET_USER_GROUP_DETAIL: (state, group) => {
    state.group = group
    if (state.group.users === null) {
      state.group.users = []
    }
    state.detailIsLoading = false
  },
  SHOW_USER_GROUP_DETAIL_UPDATE_MODAL: (state) => {
    const groupUsers = state.group.users.map(user => {
      return { id: user.id, name: user.profile.full_name, avatar: user.avatar }
    })

    state.updateModal.active = true
    state.updateModal.name = state.group.name
    state.updateModal.color = state.group.color
    state.updateModal.members = groupUsers
  },
  SET_USER_GROUP_DETAIL_UPDATE_MODAL_NAME: (state, name) => {
    state.updateModal.name = name
  },
  SET_USER_GROUP_DETAIL_UPDATE_MODAL_COLOR: (state, color) => {
    state.updateModal.color = color
  },
  ADD_USER_GROUP_DETAIL_UPDATE_MODAL_MEMBER: (state, user) => {
    state.updateModal.members.push(user)
  },
  REMOVE_USER_GROUP_DETAIL_UPDATE_MODAL_MEMBER: (state, user) => {
    state.updateModal.members = state.updateModal.members.filter(member => {
      return member.id !== user.id
    })
  },
  CLOSE_USER_GROUP_DETAIL_UPDATE_MODAL: (state) => {
    state.updateModal.active = false
    state.updateModal.name = ''
    state.updateModal.color = ''
    state.updateModal.members = []
  },
  // pagination
  SET_USER_GROUPS_PAGINATION: (state, headers) => {
    state.pagination.currentPage = Number(headers['x-pagination-current-page'])
    state.pagination.lastPage = Number(headers['x-pagination-page-count'])
    // заполняем массив номерами страниц от 1 до последней страницы
    state.pagination.pageList.pages = [...Array(Number(headers['x-pagination-page-count'])).keys()].map(i => ++i)
  },
  RESET_USER_GROUPS_CURRENT_PAGE: (state) => {
    state.pagination.currentPage = 1
  },
  SET_CURRENT_PAGE: (state, pageNum) => {
    state.pagination.currentPage = pageNum
  },
  RESET_USER_GROUPS_STORE: (state) => {
    // state.listSearchValue = ''
    // state.listSort = {
    //   value: { id: 1, name: 'Не выбрано', value: 'id' },
    //   options: [
    //     { id: 1, name: 'Не выбрано', value: 'id' },
    //     { id: 2, name: 'По алфавиту', value: 'name' },
    //     { id: 3, name: 'По дате создания', value: 'created_at' }
    //   ]
    // }
    state.pagination.currentPage = 1
  }
}

const actions = {
  // список групп
  getUserGroups ({ commit, state }) {
    const searchFilter = state.listSearchValue
    // если поиск не пустой перед запросом запускаем прелоадер, иначе при каждом запросе поиска он будет моргать
    if (!searchFilter) {
      commit('SET_USER_GROUPS_IS_LOADING')
    }

    const sort = state.listSort.value.value

    const params = {
      sort: sort,
      take: state.pagination.currentTake,
      page: state.pagination.currentPage,
      'search[name]': searchFilter
    }

    axios.get(`${url}/groups`, { params, ...config }).then(response => {
      commit('GET_USER_GROUPS', response.data.data)
      commit('SET_USER_GROUPS_PAGINATION', response.headers)
    }).catch(error => {
      console.log('Ошибка получения списка групп пользователей', error.response)
    })
  },
  userGroupsShowCreateModal ({ commit }) {
    commit('SHOW_USER_GROUPS_CREATE_MODAL')
  },
  userGroupsCreateModalSetName ({ commit }, name) {
    commit('SET_USER_GROUPS_CREATE_MODAL_NAME', name)
  },
  userGroupsCreateModalSetColor ({ commit }, color) {
    commit('SET_USER_GROUPS_CREATE_MODAL_COLOR', color)
  },
  userGroupsCreateModalAddMember ({ commit }, user) {
    commit('ADD_USER_GROUPS_CREATE_MODAL_MEMBER', user)
  },
  userGroupsCreateModalRemoveMember ({ commit }, user) {
    commit('REMOVE_USER_GROUPS_CREATE_MODAL_MEMBER', user)
  },
  userGroupsCloseCreateModal ({ commit }) {
    commit('CLOSE_USER_GROUPS_CREATE_MODAL')
  },
  userGroupsClearAndCloseCreateModal ({ commit }) {
    commit('CLEAR_CLOSE_USER_GROUPS_CREATE_MODAL')
  },
  userGroupsCreateGroup ({ commit, state }) {
    const members = state.createModal.members.map(member => {
      return member.id
    })
    const postData = {
      name: state.createModal.name,
      color: state.createModal.color,
      users: members
    }

    axios.post(`${url}/groups`, postData, config).then((response) => {
      commit('CLEAR_CLOSE_USER_GROUPS_CREATE_MODAL')
      this.dispatch('getUserGroups')
    }).catch(error => {
      console.log('Ошибка создания группы пользователей', error.response)
    })
  },
  userGroupsRemoveGroup ({ commit }, groupId) {
    axios.delete(`${url}/groups/${groupId}`, config).then((response) => {
      if (router.currentRoute.name === 'UserGroupDetail') {
        router.push('/user/groups')
      } else {
        this.dispatch('getUserGroups')
      }
    }).catch(error => {
      console.log('Ошибка удаления группы пользователей', error.response)
    })
  },
  setUserGroupsSearchValue ({ commit }, value) {
    commit('SET_USER_GROUPS_SEARCH_VALUE', value)
    commit('RESET_USER_GROUPS_CURRENT_PAGE')
    this.dispatch('getUserGroups')
  },
  setUserGroupsSort ({ commit }, sort) {
    commit('SET_USER_GROUPS_SORT', sort)
    commit('RESET_USER_GROUPS_CURRENT_PAGE')
    this.dispatch('getUserGroups')
  },

  // pagination
  getUserGroupsPage ({ commit, dispatch }, pageNum) {
    commit('SET_CURRENT_PAGE', pageNum)
    dispatch('getUserGroups')
  },
  resetUserGroupsCurrentPage ({ commit }) {
    commit('RESET_USER_GROUPS_CURRENT_PAGE')
  },

  // деталка группы
  getUserGroupDetail ({ commit, state }, groupId) {
    const expands = 'expand=users'

    axios.get(`${url}/groups/${groupId}?${expands}`, config).then(response => {
      commit('GET_USER_GROUP_DETAIL', response.data.data)
    }).catch(error => {
      console.log('Ошибка получения группы пользователей детально', error.response)
    })
  },
  userGroupDetailShowUpdateModal ({ commit }) {
    commit('SHOW_USER_GROUP_DETAIL_UPDATE_MODAL')
  },
  userGroupDetailUpdateModalSetName ({ commit }, name) {
    commit('SET_USER_GROUP_DETAIL_UPDATE_MODAL_NAME', name)
  },
  userGroupDetailUpdateModalSetColor ({ commit }, color) {
    commit('SET_USER_GROUP_DETAIL_UPDATE_MODAL_COLOR', color)
  },
  userGroupDetailUpdateModalAddMember ({ commit }, user) {
    commit('ADD_USER_GROUP_DETAIL_UPDATE_MODAL_MEMBER', user)
  },
  userGroupDetailUpdateModalRemoveMember ({ commit }, user) {
    commit('REMOVE_USER_GROUP_DETAIL_UPDATE_MODAL_MEMBER', user)
  },
  userGroupDetailCloseUpdateModal ({ commit }) {
    commit('CLOSE_USER_GROUP_DETAIL_UPDATE_MODAL')
  },
  userGroupDetailUpdateGroup ({ commit, state }) {
    const groupId = state.group.id
    const members = state.updateModal.members.map(member => {
      return member.id
    })
    const updateData = {
      name: state.updateModal.name,
      color: state.updateModal.color
    }
    const updateUsers = {
      users: members
    }
    const putMembers = axios.put(`${url}/groups/${groupId}/sync`, updateUsers, config)
    const putData = axios.put(`${url}/groups/${groupId}`, updateData, config)

    axios.all([putData, putMembers]).then(response => {
      commit('CLOSE_USER_GROUP_DETAIL_UPDATE_MODAL')
      this.dispatch('getUserGroupDetail', groupId)
    }).catch(error => {
      console.log('Ошибка редактирования группы пользователей', error.response)
    })
  },
  removeUserGroupMember ({ commit, state }, memberId) {
    const groupId = state.group.id
    const updateData = {
      users: [memberId]
    }

    axios.put(`${url}/groups/${groupId}/detach`, updateData, config).then((response) => {
      this.dispatch('getUserGroupDetail', groupId)
    }).catch(error => {
      console.log('Ошибка удаления пользователя из группы пользователей', error.response)
    })
  },
  setUserGroupDetailSearchValue ({ commit, state }, value) {
    const groupId = state.group.id
    const expands = 'expand=users'

    axios.get(`${url}/groups/${groupId}?${expands}`, config).then(response => {
      commit('GET_USER_GROUP_DETAIL', response.data.data)
      const users = [...state.group.users]
      state.group.users = users.filter(user => {
        return user.profile.full_name.indexOf(value) + 1
      })
    }).catch(error => {
      console.log('Ошибка получения группы пользователей при поиске', error.response)
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
